import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCross = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.9472 2.90381L7.50001 6.35095L4.05286 2.90381C3.70815 2.55909 3.24853 2.55909 2.90381 2.90381C2.5591 3.24852 2.5591 3.70814 2.90381 4.05285L6.35096 7.5L2.90381 10.9471C2.5591 11.2919 2.5591 11.7515 2.90381 12.0962C3.24853 12.4409 3.70815 12.4409 4.05286 12.0962L7.50001 8.64905L10.9472 12.0962C11.2919 12.4409 11.7515 12.4409 12.0962 12.0962C12.4409 11.7515 12.4409 11.2919 12.0962 10.9471L8.64905 7.5L12.0962 4.05285C12.4409 3.70814 12.4409 3.24852 12.0962 2.90381C11.7515 2.55909 11.2919 2.55909 10.9472 2.90381Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconCross;
